import React, { useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import { HelpCircle } from 'lucide-react';

/**
 * PortalTour provides an interactive step‑by‑step guide for clients.
 * It can be triggered automatically on first login or manually via a floating help button.
 */
const PortalTour = ({ steps, onTourEnd, autoStart = false }) => {
  const [run, setRun] = useState(autoStart);
  const [stepIndex, setStepIndex] = useState(0);

  const handleStart = () => {
    setRun(true);
    setStepIndex(0);
  };

  const handleJoyrideCallback = (data) => {
    const { status, index } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRun(false);
      onTourEnd && onTourEnd();
    } else {
      setStepIndex(index + 1);
    }
  };

  return (
    <>
      {/* Floating help button */}
      <button
        onClick={handleStart}
        className="fixed bottom-4 right-4 z-50 p-3 bg-[var(--primary)] text-white rounded-full shadow-lg hover:bg-[var(--primary-dark)]"
        aria-label="Help Tour"
      >
        <HelpCircle className="w-5 h-5" />
      </button>

      <Joyride
        steps={steps}
        run={run}
        stepIndex={stepIndex}
        continuous
        showSkipButton
        showProgress
        callback={handleJoyrideCallback}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
      />
    </>
  );
};

export default PortalTour;
